export default __webpack_public_path__ + "static/media/decrypted-logo-white.a70db16b.svg";